import logo from "../../assets/logo.svg";
import gangalogo from "../../assets/Logos/gangalogo.jpg";
import appStoreIcon from "../../assets/appStore.svg";
import Twittericon from "../../assets/twitter.svg";
import facebookIcon from "../../assets/facebook.svg";
import spclty_bg from "../../assets/speciality_head.svg";
import search from "../../assets/search.svg";
import TickIcon from "../../assets/TickIcon.svg";
import appointment from "../../assets/appointment.svg";
import time from "../../assets/time.svg";
import rightArrow from "../../assets/rightArrow.svg";
import siginup_bg from "../../assets/siginup_bg.svg";
import appSrore from "../../assets/appSrore.svg";
import playStore from "../../assets/playStore.svg";
import hospitalLogo from "../../assets/hospitalLogo.png";
import nextArrow from "../../assets/nextArrow.svg";
import speciality1 from "../../assets/Speciality/speciality1.svg";
import speciality2 from "../../assets/Speciality/speciality2.svg";
import speciality3 from "../../assets/Speciality/speciality3.svg";
import speciality4 from "../../assets/Speciality/speciality4.svg";
import speciality5 from "../../assets/Speciality/speciality5.svg";
import speciality6 from "../../assets/Speciality/speciality6.svg";
import speciality7 from "../../assets/Speciality/speciality7.svg";
import speciality8 from "../../assets/Speciality/speciality8.svg";
import speciality9 from "../../assets/Speciality/speciality9.svg";
import speciality10 from "../../assets/Speciality/speciality10.svg";
import speciality11 from "../../assets/Speciality/speciality11.svg";
import speciality12 from "../../assets/Speciality/speciality12.svg";
import speciality13 from "../../assets/Speciality/speciality13.svg";
import speciality14 from "../../assets/Speciality/speciality14.svg";
import speciality15 from "../../assets/Speciality/speciality15.svg";
import speciality16 from "../../assets/Speciality/speciality16.svg";
import speciality17 from "../../assets/Speciality/speciality17.svg";
import speciality18 from "../../assets/Speciality/speciality18.svg";
import speciality19 from "../../assets/Speciality/speciality19.svg";
import speciality20 from "../../assets/Speciality/speciality20.svg";
import speciality21 from "../../assets/Speciality/speciality21.svg";
import speciality22 from "../../assets/Speciality/speciality22.svg";
import speciality23 from "../../assets/Speciality/speciality23.svg";
import speciality24 from "../../assets/Speciality/speciality24.svg";

import arrow from "../../assets/microsite/arrow.png";
import computer from "../../assets/microsite/computer.svg";
import mobile from "../../assets/microsite/mobile.svg";
import one from "../../assets/microsite/01.svg";
import two from "../../assets/microsite/02.svg";
import three from "../../assets/microsite/03.svg";
import four from "../../assets/microsite/04.svg";
import man_doctor from "../../assets/microsite/man-doctor.png";
import andriod from "../../assets/microsite/andriod.png";
import apple from "../../assets/microsite/apple.png";
import card1 from "../../assets/microsite/card1.png";
import card2 from "../../assets/microsite/card2.svg";
import card3 from "../../assets/microsite/card3.png";
import card4 from "../../assets/microsite/card4.png";
import location from "../../assets/microsite/location.svg";
import email from "../../assets/microsite/email.svg";
import location_pic from "../../assets/microsite/location-pic.png";
import shalbylogo from "../../assets/microsite/shalbylogo.png";
import Our_doctors from "../../assets/microsite/Our-doctors.svg";
import How_it_works from "../../assets/microsite/How-it-works.svg";
import Treatments from "../../assets/microsite/Treatments.svg";
import Contact_Us from "../../assets/microsite/Contact_Us.svg";
import Footer from "../../assets/microsite/MicrositeFooter.svg";
import smartPhone from "../../assets/microsite/smartphone.svg";
import doctorProfile from "../../assets/doctorProfile.png";
import tick_Outline from "../../assets/DoctorListing/tick.svg";

import doctor_icon from "../../assets/signup/doctor_icon.svg";
import patient_icon from "../../assets/signup/patient_icon.svg";
import bg from "../../assets/signin/bg.svg";
import pass from "../../assets/signin/pass.svg";
import changed from "../../assets/signin/changed.svg";
import search_icon from "../../assets/DoctorListing/search_icon.svg";
import arrow_right from "../../assets/DoctorListing/arrow_right.svg";
import reset_icon from "../../assets/DoctorListing/reset_icon.svg";
import hospital_icon from "../../assets/DoctorListing/hospital_icon.png";
import location_icon from "../../assets/DoctorListing/location_icon.svg";
import timer_icon from "../../assets/DoctorListing/timer_icon.svg";
import fee_icon from "../../assets/DoctorListing/fee_icon.svg";
import close_icon from "../../assets/DoctorListing/close_icon.svg";
import down_arrow from "../../assets/DoctorListing/down_arrow.svg";
import modal_close_icon from "../../assets/DoctorListing/modal_close_icon.svg";
import previous_icon from "../../assets/BookAppointment/previous_icon.svg";
import warning_icon from "../../assets/BookAppointment/warning_icon.svg";
import person_icon from "../../assets/BookAppointment/person_icon.svg";
import pencil_icon from "../../assets/BookAppointment/pencil_icon.svg";
import sj_icon from "../../assets/BookAppointment/sj_icon.svg";
import plus_icon from "../../assets/BookAppointment/plus_icon.svg";
import right_arrow_icon from "../../assets/BookAppointment/right_arrow_icon.svg";
import male_icon from "../../assets/BookAppointment/male_icon.svg";
import upload_icon from "../../assets/BookAppointment/upload_icon.svg";
import help_arrow from "../../assets/BookAppointment/help_arrow.svg";
import tick_icon from "../../assets/BookAppointment/tick_icon.svg";
import reason_tick_icon from "../../assets/BookAppointment/reason_tick_icon.svg";
import pdf_icon from "../../assets/BookAppointment/pdf_icon.svg";
import file_icon from "../../assets/BookAppointment/file_icon.svg";
import blue_bg from "../../assets/aboutus/blue_bg.svg";
import blue_hrt from "../../assets/aboutus/blue_hrt.svg";
import doc from "../../assets/aboutus/doc.png";
import green_hrt from "../../assets/aboutus/green_hrt.svg";
import red_hrt from "../../assets/aboutus/red_hrt.svg";
import lower_grid from "../../assets/aboutus/lower_grid.svg";
import upper_grid from "../../assets/aboutus/upper_grid.svg";
import man1 from "../../assets/aboutus/man1.png";
import man2 from "../../assets/aboutus/man2.png";
import man3 from "../../assets/aboutus/man3.png";
import man4 from "../../assets/aboutus/man4.png";
import qts from "../../assets/aboutus/qts.svg";
import educating from "../../assets/aboutus/educating.png";
import artisan from "../../assets/aboutus/artisan.png";
import medtech from "../../assets/aboutus/medtech.png";
import success_icon from "../../assets/BookAppointment/success_icon.svg";
import calender_icon from "../../assets/BookAppointment/calender_icon.svg";
import filter_icon from "../../assets/MobileScreens/filter_icon.svg";
import footer_img from "../../assets/MobileScreens/footer_img.png";
import google_play_icon from "../../assets/MobileScreens/google_play_icon.svg";
import app_store_icon from "../../assets/MobileScreens/app_store_icon.svg";
import filter_close from "../../assets/MobileScreens/filter_close.svg";
import filter_refresh from "../../assets/MobileScreens/reset_icon.svg";
import appointment_type_icon from "../../assets/MobileScreens/appointment_type_icon.svg";
import group_icon from "../../assets/MobileScreens/group_icon.png";
import mini_tick from "../../assets/MobileScreens/mini_tick.svg";
import globe_icon from "../../assets/MobileScreens/globe_icon.svg";
import blue_edit_icon from "../../assets/BookAppointment/blue_edit_icon.svg";
import icon_arrow_blue from "../../assets/BookAppointment/icon_arrow_blue.svg";
import icon_person_blue from "../../assets/BookAppointment/icon_person_blue.svg";
import icon_plus_blue from "../../assets/BookAppointment/icon_plus_blue.svg";
import icon_sj_blue from "../../assets/BookAppointment/icon_sj_blue.svg";
import nodataFound from "../../assets/Nodata.svg";
import icon_android from "../../assets/icon_android.svg";
import icon_ios from "../../assets/icon_ios.svg";

import ambulance from "../../assets/ambulance.svg";
import iconpassword from "../../assets/icon-password.svg";
import female_icon from "../../assets/BookAppointment/female_icon.svg";
import othergender from "../../assets/BookAppointment/othergender.svg";
import avatar from "../../assets/DoctorListing/avatar.svg";
import deleteIcon from "../../assets/BookAppointment/deleteIcon.svg";
import signupTick from "../../assets/signup/signupTick.svg";
import closeIcon from "../../assets/BookAppointment/closeIcon.svg";
import modalClose from "../../assets/BookAppointment/modalClose.svg";
import terms_bg from "../../assets/terms_bg.svg";
import Ellipse from "../../assets/Ellipse 309.svg";
import EllipseTick from "../../assets/ForPatients/EllipseTick.svg";
import patientImg1 from "../../assets/ForPatients/patientImg1.png";
import symtomsClose from "../../assets/BookAppointment/symtomsClose.svg";
import bin from "../../assets/BookAppointment/bin.svg";
import arrowIcon from "../../assets/arrowIcon.png";
import bhm from "../../assets/bhm.png";
import INDIA from "../../assets/INDIA.svg";
import upload_close_icon from "../../assets/BookAppointment/upload_close_icon.svg";
import helparrow2 from "../../assets/BookAppointment/helparrow2.svg";
import addblue from "../../assets/addblue.svg";
import eye from "../../assets/eye.svg";
import info from "../../assets/info.svg";
import report from "../../assets/BookAppointment/ic_reports.svg";
import medication from "../../assets/BookAppointment/ic_medication.svg";
import surgery from "../../assets/BookAppointment/ic_surgery.svg";
import allergies from "../../assets/BookAppointment/ic_allergies.svg";
import medical_conditions from "../../assets/BookAppointment/ic_medical_conditions.svg";
import symptoms from "../../assets/BookAppointment/ic_symptoms.svg";
import gangaHospitalImage from '../../assets/ganga/hos_image.jpg'
import reem_branding from "../../assets/Reem-Logo-1.svg";

const Assets = {
  helparrow2,
  upload_close_icon,
  bhm,
  INDIA,
  arrowIcon,
  symtomsClose,
  bin,
  female_icon,
  othergender,
  educating,
  artisan,
  medtech,
  man1,
  man2,
  man3,
  man4,
  qts,
  playStore,
  blue_bg,
  blue_hrt,
  doc,
  green_hrt,
  red_hrt,
  lower_grid,
  upper_grid,
  pass,
  changed,
  bg,
  Footer,
  Contact_Us,
  How_it_works,
  Treatments,
  shalbylogo,
  Our_doctors,
  logo,
  appStoreIcon,
  Twittericon,
  facebookIcon,
  spclty_bg,
  search,
  speciality1,
  speciality2,
  speciality3,
  speciality4,
  speciality5,
  speciality6,
  speciality7,
  speciality8,
  speciality9,
  speciality10,
  speciality11,
  speciality12,
  speciality13,
  speciality14,
  speciality15,
  speciality16,
  speciality17,
  speciality18,
  speciality19,
  speciality20,
  speciality21,
  speciality22,
  speciality23,
  speciality24,
  TickIcon,
  appointment,
  time,
  rightArrow,
  arrow,
  computer,
  mobile,
  one,
  two,
  three,
  four,
  man_doctor,
  andriod,
  apple,
  card1,
  card2,
  card3,
  card4,
  email,
  location,
  location_pic,
  doctor_icon,
  patient_icon,
  siginup_bg,
  search_icon,
  arrow_right,
  reset_icon,
  hospital_icon,
  location_icon,
  timer_icon,
  fee_icon,
  close_icon,
  down_arrow,
  modal_close_icon,
  previous_icon,
  warning_icon,
  person_icon,
  pencil_icon,
  sj_icon,
  plus_icon,
  right_arrow_icon,
  male_icon,
  upload_icon,
  help_arrow,
  tick_icon,
  reason_tick_icon,
  appSrore,
  playStore,
  appSrore,
  hospitalLogo,
  nextArrow,
  doctorProfile,
  pdf_icon,
  file_icon,
  tick_Outline,
  success_icon,
  calender_icon,
  filter_icon,
  footer_img,
  google_play_icon,
  app_store_icon,
  filter_close,
  filter_refresh,
  appointment_type_icon,
  group_icon,
  mini_tick,
  globe_icon,
  blue_edit_icon,
  icon_arrow_blue,
  icon_person_blue,
  icon_plus_blue,
  icon_sj_blue,
  nodataFound,
  icon_android,
  icon_ios,
  ambulance,
  iconpassword,
  female_icon,
  avatar,
  deleteIcon,
  signupTick,
  closeIcon,
  modalClose,
  terms_bg,
  Ellipse,
  EllipseTick,
  patientImg1,
  smartPhone,
  addblue,
  eye,
  info,
  report,
  medication,
  surgery,
  allergies,
  medical_conditions,
  symptoms,
  gangalogo,
  gangaHospitalImage,
  reem_branding,
};
export default Assets;
